<template>
  <v-icon v-text="text" :color="color"></v-icon>
</template>

<script>
export default {
  name: 'StatusIcon',
  props: {
    text: {
      type: String,
      default: 'mdi-checkbox-blank-circle-outline'
    },
    color: {
      type: String,
      default: ''
    }
  }
}
</script>

<style>

</style>